<div class="page-header">
  <h2 class="page-title">{{ title }}</h2>
  <p class="page-description" *ngIf="description">{{ description }}</p>

  <div class="toolbar">
    <ng-content></ng-content>
  </div>
</div>
